/**
 * Framingham Heart Failure diagnostic criteria (major / minor checklist).
 * Distinct from the Framingham 10-year Hard CHD risk score.
 */

export type FraminghamHfCriterion = {
  code: string;
  display: string;
};

export const FRAMINGHAM_HF_MAJOR_CRITERIA: FraminghamHfCriterion[] = [
  { code: "pulmonaryEdema", display: "Acute pulmonary edema" },
  { code: "cardiomegaly", display: "Cardiomegaly" },
  { code: "hepatojugularReflux", display: "Hepatojugular reflux" },
  { code: "neckVeinDistension", display: "Neck vein distension" },
  {
    code: "pndOrOrthopnea",
    display: "Paroxysmal nocturnal dyspnea or orthopnea",
  },
  { code: "pulmonaryRales", display: "Pulmonary rales" },
  { code: "s3Gallop", display: "Third heart sound (S3 gallop rhythm)" },
  {
    code: "increasedCvp",
    display: "Increased central venous pressure (>16 cm H2O)",
  },
  {
    code: "weightLoss",
    display: "Weight loss >4.5kg in 5 days in response to treatment",
  },
];

export const FRAMINGHAM_HF_MINOR_CRITERIA: FraminghamHfCriterion[] = [
  { code: "ankleEdema", display: "Bilateral ankle edema" },
  { code: "dyspneaOnExertion", display: "Dyspnea on exertion" },
  { code: "hepatomegaly", display: "Hepatomegaly" },
  { code: "nocturnalCough", display: "Nocturnal cough" },
  { code: "pleuralEffusion", display: "Pleural effusion" },
  { code: "tachycardia", display: "Tachycardia (HR >120)" },
  {
    code: "decreasedVitalCapacity",
    display: "Decrease in vital capacity by one third from maximum",
  },
];

/** Positive when ≥2 major, or 1 major + ≥2 minor. */
export function evaluateHfCriteria(
  majorCount: number,
  minorCount: number,
): boolean {
  return majorCount >= 2 || (majorCount >= 1 && minorCount >= 2);
}

export function emptyHfCriteriaSelection(
  criteria: FraminghamHfCriterion[],
): Record<string, boolean> {
  return Object.fromEntries(criteria.map(({ code }) => [code, false]));
}
